import * as actionTypes from "./actionTypes";

const initialState = {
    auth: null,
    // false until the stored session has been read on boot
    authChecked: false,
    section: "",
    allPermissionJson: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_AUTH_DATA:
            return {
                ...state,
                auth: action.payload,
                authChecked: true,
            };
        case actionTypes.AUTH_CHECKED:
            return {
                ...state,
                authChecked: true,
            };
        case actionTypes.UPDATE_REDUCER:
            return {
                ...state,
                [action.payload.key]: action.payload.data,
            };
        case actionTypes.RESET:
            // Session was explicitly cleared — that still counts as "checked",
            // otherwise the router would stall instead of showing the login page.
            return {
                ...initialState,
                authChecked: true,
            };
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default reducer;
